import { ILabelStyles, concatStyleSets } from 'office-ui-fabric-react';
import { AppLayoutSettings } from '../common.styles';

export const getBottomLabelStyles = (): ILabelStyles => {
  return AppLayoutSettings.AppCommonStyles.getRegularLabelStyles(AppLayoutSettings.AppFontSize.mediumFontSizePx, AppLayoutSettings.AppColors.mediumLabelColor);
};

export const getFileInputStyles = () => {
  return AppLayoutSettings.AppCommonStyles.getFileInputStyles(AppLayoutSettings.AppDisplayType.none);
};

export const getEnglishOnlyLabelStyles = () => {
  const commonLabelStyles = AppLayoutSettings.AppCommonStyles.getPageTopLabelStyles();
  const specificStyle = {
    root: {
      marginTop: '9px'
    }
  }
  return concatStyleSets(commonLabelStyles, specificStyle);
}
